module.exports = __webpack_public_path__ + "img/itsm7.662ed211.png";